import styled from 'styled-components';

const Wrapper = styled.label`
  display: flex;
  cursor: pointer;
  font-weight: 600;
  line-height: 1.63;
`;

export default Wrapper;